import store from "../store/index";
export default {
    async bind(){

    },
    async inserted(el, binding) {
        // 默认先改为 none，等数据回来之后再进行操作，你通过class来控制
        el.style.display = "none";
        let _permissions = store.state.permission
        let  user = JSON.parse(window.localStorage.getItem("user"));
        let hasPermission = _permissions.some(s=>s.key === binding.value && s.permission.length)
        console.log(hasPermission)
        if (hasPermission || user.power === 1) {
            el.style.display = "";
        } else {
            el.parentNode?.removeChild(el); // 移除元素
        }
    },

}